import React from "react";

const Experience = () => {
  const experienceData = [
    {
      id: 1,
      period: "September 2023 - Present",
      company: "DevRev",
      logo: "https://devrev.gallerycdn.vsassets.io/extensions/devrev/devrev-snap-in/0.0.3/1722504742330/Microsoft.VisualStudio.Services.Icons.Default",
      position: "Member of Technical Staff Intern",
      location: "Chennai, India",
      contributions: [
        "Rewrote Front-end components to separate the data layer from the UI layer, enabling dynamic field rendering based on AI-driven analytics results",
        "Enhanced the omnipresent AI-agent frontend by integrating contextual understanding and dynamic thought processes.",
      ],
    },
    {
      id: 2,
      period: "August 2023 - December 2023",
      company: "Samsung R&D India",
      logo: "https://media.licdn.com/dms/image/v2/D560BAQFhkwNLmYJr9A/company-logo_200_200/company-logo_200_200/0/1725008298192/samsungrndindiabangalore_logo?e=2147483647&v=beta&t=AZb0rjquikmqV02Nxu2tEiyGYgZJpQcT8rU_D-nTMZU",
      position: "PRISM Intern",
      location: "Bangalore/ Remote, India",
      contributions: [
        "Developed an Automatic Question Generator for Voice Assistants using Python, Web Scraping, Natural Language Processing - Text-to-Text Transform Transformer, Regex and Python libraries.",
        "Developed a framework for processing multiple inputs to generate questions to enhance Voice Assistant efficiency.",
        "Achieved efficiency of 85% correction in AQG and Awarded Certificate of Excellence by Samsung RD Institute.",
      ],
    },
  ];

  return (
    <section id="experience" className="py-6 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Experience
        </h2>

        <div className="space-y-8">
          {experienceData.map((item) => (
            <div
              key={item.id}
              className="p-6 bg-white rounded-lg border border-gray-200 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4 mb-4">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10  overflow-hidden border border-gray-300 flex-shrink-0">
                      <img
                        src={item.logo}
                        alt={`${item.company} logo`}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = `https://via.placeholder.com/40/4F46E5/FFFFFF?text=${item.company.charAt(
                            0
                          )}`;
                        }}
                      />
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">
                      {item.company}
                    </h3>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-700">
                    {item.position}
                  </h4>
                  <p className="text-gray-600 italic mb-3">{item.location}</p>
                </div>
                <div className="md:min-w-[180px] md:text-right">
                  <span className="inline-block bg-blue-100 text-blue-800 text-lg font-medium px-4 py-2 rounded-lg shadow-sm">
                    {item.period}
                  </span>
                </div>
              </div>

              <div className="w-full">
                <h5 className="text-md font-semibold text-gray-700 mb-2">
                  Contributions:
                </h5>
                <ul className="list-disc pl-5 space-y-1">
                  {item.contributions.map((contribution, i) => (
                    <li key={i} className="text-gray-700">
                      {contribution}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
